import { DocumentRepository } from "../repositories/DocumentRepository";
import { UploadResultEntity, DocumentType } from "../entities/Document";

/**
 * Upload Documents Use Case
 * Handles document upload with validation
 */
export class UploadDocumentsUseCase {
  // private readonly MAX_FILES = 10;
  private readonly ALLOWED_TYPES = [".pdf", ".doc", ".docx", ".xls", ".xlsx"];

  constructor(private repository: DocumentRepository) {}

  async execute(
    files: File[],
    documentType: DocumentType,
    companyId: string
  ): Promise<UploadResultEntity> {
    // Validate file count
    if (files.length === 0) {
      throw new Error("No files selected");
    }

    // if (files.length > this.MAX_FILES) {
    //   throw new Error(`Maximum ${this.MAX_FILES} files allowed per upload`);
    // }

    // Validate file types
    // for (const file of files) {
    //   const fileName = file.name.toLowerCase();
    //   const extension = fileName.substring(fileName.lastIndexOf("."));

    //   if (!this.ALLOWED_TYPES.includes(extension)) {
    //     throw new Error(
    //       `Invalid file type: ${extension} in file "${file.name}". Please select PDF, DOC, DOCX, XLS, or XLSX files only.`
    //     );
    //   }
    // }

    // Validate company ID
    if (!companyId) {
      throw new Error("Company ID is required");
    }

    // Upload through repository
    return await this.repository.uploadDocuments(
      files,
      documentType,
      companyId
    );
  }
}
